export const SET_ZONES_DATA = 'SET_ZONES_DATA'
export const CHECK_FULL_PROVINCE = 'CHECK_FULL_PROVINCE'
export const CHECK_FULL_CC_AA = 'CHECK_FULL_CC_AA'
export const CHECK_FROM_CODES = 'CHECK_FROM_CODES'
export const CHECK_SINGLE_ZIP = 'CHECK_SINGLE_ZIP'
